
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiSimplifiedBuoyLateralConicalGreen as ObiSimplifiedBuoyLateralConicalGreenElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-simplified-buoy-lateral-conical-green.js';
 
 
 

 
 export const ObiSimplifiedBuoyLateralConicalGreen = createComponent({
   react: React,
   tagName: 'obi-simplified-buoy-lateral-conical-green',
   elementClass: ObiSimplifiedBuoyLateralConicalGreenElement,
   events: {
     
   }
  });
 
 